import { Stack, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation('landing');
  return (
    <Stack direction='column' alignItems='center'>
      <Typography
        variant='h6'
        sx={{
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '18px',
          color: '#0B1370',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        {t('footer_text', {
          year: new Date().getFullYear(),
        })}
      </Typography>
    </Stack>
  );
};
